export default __webpack_public_path__ + "static/media/st-logo.16a0d933.png";